import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'AE',
    name: 'Królowa Roju',
    id: 'CarapaceQueen',
    health: 60,
    difficulty: 3,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'AE',
    name: 'Maska Kłamstw',
    id: 'CrookedMask',
    health: 70,
    difficulty: 5,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'AE',
    name: 'Książę Pożeraczy',
    id: 'PrinceOfGluttons',
    health: 70,
    difficulty: 5,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'AE',
    name: 'Gnieworodny',
    id: 'Rageborne',
    health: 70,
    difficulty: 2,
    expeditionRating: 1,
    additionalInfo: '',
  },
]
